<template>
    <div class="box"
      v-bind:style="{ top: top, left: left }"
      v-bind:class="{ shake }">
        <div class="box-title">
            <img src="@/assets/windows95.png" width="18" height="18" />
            <p class="title">Windows 95</p>
            <button v-on:click="click">X</button>
            <button>?</button>
        </div>
        <div class="box-content">
            <p>{{ message }}</p>
            <button v-on:click="click">OK</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    message: String,
    top: String,
    left: String,
    shake: String
  },
  methods: {
    click: function () {
      this.$emit('click')
    }
  }
}
</script>
